import { __rest, __assign } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';
import { Wrapper, WrapperInput, Suprefix, StyledInput } from './styles.js';
import { SuprefixContent } from './SuprefixContent.js';

var Input = forwardRef(function (_a, ref) {
    var label = _a.label, helperText = _a.helperText, feedback = _a.feedback, Suffix = _a.suffix, Prefix = _a.prefix, isLoading = _a.isLoading, disabled = _a.disabled, readOnly = _a.readOnly, id = _a.id, props = __rest(_a, ["label", "helperText", "feedback", "suffix", "prefix", "isLoading", "disabled", "readOnly", "id"]);
    var hasInteractiveEl = function () {
        if (isLoading || feedback)
            return !disabled && !readOnly;
    };
    return (React.createElement(Wrapper, null,
        label && (React.createElement(ParagraphMd, { bold: true, as: "label", htmlFor: id }, label)),
        React.createElement(WrapperInput, { feedback: feedback, disabled: disabled, readOnly: readOnly, isLoading: isLoading },
            Prefix && (React.createElement(Suprefix, null,
                React.createElement(SuprefixContent, { el: Prefix }))),
            React.createElement(StyledInput, __assign({}, props, { id: id, disabled: disabled, readOnly: readOnly })),
            Suffix && (React.createElement(Suprefix, { sufix: true },
                React.createElement(SuprefixContent, { el: Suffix }))),
            hasInteractiveEl() && (React.createElement(Suprefix, { sufix: true },
                React.createElement(SuprefixContent, { isLoading: isLoading, feedback: feedback, hasInteractiveEl: true })))),
        helperText && React.createElement(Caption, null, helperText)));
});

export { Input as default };
